import { Component } from 'react'
import { object } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Helmet } from 'react-helmet'
import { withStyles } from '@material-ui/core/styles'
import HeaderTitle from '../Header/HeaderTitle'
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Tooltip,
} from '@material-ui/core'
import {
  setListSelectionData,
  setCountryLinkRestrictionFlag,
  setListData,
  setTitleData,
  setPhoneMessageData,
  setSMSMessageData,
  setEmailMessageData,
  setContactData,
  setDelayData,
  setNotifyData,
  setDistanceFlagData,
  setDistanceData,
  setWorkerTypesData,
  setLanguageData,
  setEnglishPositiveResponseData,
  setEnglishNegativeResponseData,
  setSpanishPositiveResponseData,
  setSpanishNegativeResponseData,
  setScheduleData,
  setCIData,
  setListInputData,
  setListInputType,
  homepageCreate,
} from './../../store/Homepage/actionCreator'
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/moment'
import {
  DateRange,
  AccessTime,
  ArrowBack,
  ArrowForward,
} from '@material-ui/icons'
import moment from 'moment-timezone'
import MomentUtils from '@date-io/moment'
import WarningIcon from '@material-ui/icons/Warning'
import ErrorIcon from '@material-ui/icons/Error'
import WorkerTextBox from '../WorkerLookupLayout/WorkerTextBox'
import WorkerLookupTable from '../WorkerLookupLayout/WorkerLookupTable'
import MessageCreateForm from '../MessageCreate/MessageCreateForm'
import MessageTemplateSelectPage from '../MessageTemplateSelect/MessageTemplateSelectPage'
import HomepageResponse from './HomepageResponse'
import ReorderList from '../ContactMethod/ReorderList'
import { DelayItem } from '../ContactMethod/DelayItem'
import DistanceItem from '../ContactMethod/DistanceItem'
import DistanceDropdownItem from '../ContactMethod/DistanceDropdownItem'
import NotifyItem from '../ContactMethod/NotifyItem'
import LanguageSwitch from '../Language/LanguageSwitch'
import SelectTimezoneItem, {
  FindTimezone,
} from '../ReportingPage/SelectTimezoneItem'
import {
  countFollowups,
  setDelay,
  setTitle,
  checkifEmpty,
  setValidMessage,
  initContactData,
  isWorkerListPopulated,
  getContactMethods,
  displayLanguage,
  getTotalSMSCharacters,
  distroListOnlyValidation,
  isMessagePopulated,
  setHidePhoneFlag,
  itemsValidation,
  displayContacts,
  displayContactMethod,
  displayDelay,
  displayNotify,
  displayProximityWorkerTypes,
  setDistance,
  setWorkerType,
  setPrimaryJobCodes,
  setFailoverJobCodes,
  setNotifySupervisorJobCodesList,
  finaltime,
  getSteps,
} from '../HomePage/helperFunctions'
import { useOutletContext } from 'react-router-dom'

function withOutletContext(WrappedComponent) {
  return function WrapperComponent(props) {
    const outletContext = useOutletContext()
    return <WrappedComponent {...props} outletContext={outletContext} />
  }
}

const styles = (theme) => ({
  homePage: {
    textAlign: 'center',
  },
  homePageIntro: {
    fontSize: 'large',
  },
  button: {
    marginRight: '1px',
  },
  instructions: {
    marginTop: '1px',
    marginBottom: '1px',
  },
  centerList: {
    margin: 'auto',
    minWidth: '250px',
    maxWidth: '50%',
    padding: '10px',
    whiteSpace: 'pre-line',
  },
  centerListSmall: {
    margin: 'auto',
    minWidth: '250px',
    maxWidth: '25%',
    padding: '10px',
  },
  centerListText: {
    margin: 'auto',
    minWidth: '250px',
    maxWidth: '50%',
    whiteSpace: 'pre-line',
    textAlign: 'center',
  },
  formControl: {
    marginLeft: 'auto',
    marginRight: 'auto',
    minWidth: '250px',
    maxWidth: '50%',
  },
})

class HomePage extends Component {
  static propTypes = {
    classes: object,
  }

  constructor(props) {
    super(props)
    this.state = {
      selectionData: {},
      countryLinkRestrictionFlagFromChild: false,
      listDataFromChild: {},
      listWorkerTotalFromChild: 0,
      activeStep: 0,
      skipped: new Set(),
      validProximityWorkerTypes: true,
      validData: false,
      titleFromChild: '',
      phoneMessageFromChild: '',
      smsMessageFromChild: '',
      emailMessageFromChild: '',
      validMessage: false,
      titleDataFromChild: '',
      phoneMessageDataFromChild: '',
      smsMessageDataFromChild: '',
      emailMessageDataFromChild: '',
      dialogOpen: false,
      submitResponse: '',
      contactDataFromChild: {},
      delayDataFromChild: {},
      notifyDataFromChild: true,
      distanceFlagDataFromChild: false,
      distanceDataFromChild: 0,
      workerTypesDataFromChild: {},
      languageDataFromChild: '',
      englishPositiveResponseFromChild: '',
      englishNegativeResponseFromChild: '',
      spanishPositiveResponseFromChild: '',
      spanishNegativeResponseFromChild: '',
      englishPositiveResponseDataFromChild: '',
      englishNegativeResponseDataFromChild: '',
      spanishPositiveResponseDataFromChild: '',
      spanishNegativeResponseDataFromChild: '',
      validContactData: true,
      scheduleDataFromChild: new Date(),
      ciData: '',
      listInput: '',
      listType: '',
      headerTitle: '',
      timezoneDataFromChild: '',
    }
  }
  UNSAFE_componentWillMount() {
    const { outletContext } = this.props
    if (outletContext) {
      this.setState({
        selectionData: {},
        countryLinkRestrictionFlagFromChild: false,
        listDataFromChild: this.setData('listData', 'setListData', {}),
        listWorkerTotalFromChild: countFollowups(
          this.setData('listData', '', {}),
        ),
        activeStep: this.setActiveStep(),
        skipped: new Set(),
        validProximityWorkerTypes: true,
        validData: setValidMessage(this.setActiveStep()),
        titleFromChild: checkifEmpty(this.setData('messageTitle', '')),
        phoneMessageFromChild: checkifEmpty(this.setData('messagePhone', '')),
        smsMessageFromChild: checkifEmpty(this.setData('messageSMS', '')),
        emailMessageFromChild: checkifEmpty(this.setData('messageEmail', '')),
        validMessage: checkifEmpty(this.setActiveStep()),
        titleDataFromChild: this.setData('messageTitle', 'setTitleData'),
        phoneMessageDataFromChild: this.setData(
          'messagePhone',
          'setPhoneMessageData',
        ),
        smsMessageDataFromChild: this.setData(
          'messageSMS',
          'setSMSMessageData',
        ),
        emailMessageDataFromChild: this.setData(
          'messageEmail',
          'setEmailMessageData',
        ),
        dialogOpen: false,
        submitResponse: '',
        contactDataFromChild: initContactData(
          this.setData('contactMethods', ''),
          this.setData('ciDataInput', ''),
        ),
        delayDataFromChild: this.setData(
          'contactDelay',
          'setDelayData',
          setDelay(this.setData('ciDataInput', '')),
        ),
        notifyDataFromChild: this.setData('notifyOnly', 'setNotifyData', true),
        distanceFlagDataFromChild: this.setData(
          'contactDistanceFlag',
          'setDistanceFlagData',
          false,
        ),
        distanceDataFromChild: this.setData(
          'contactDistance',
          'setDistanceData',
          0,
        ),
        workerTypesDataFromChild: this.setData(
          'contactDistanceWorkerTypes',
          'setWorkerTypesData',
          {
            str: true,
            office: true,
            rgd: true,
            dc: true,
            test: true,
            shipt: true,
          },
        ),
        languageDataFromChild: this.props.languageDataFromChild,
        englishPositiveResponseFromChild: checkifEmpty(
          this.setData('messageResponsePositive', ''),
        ),
        englishNegativeResponseFromChild: checkifEmpty(
          this.setData('messageResponseNegative', ''),
        ),
        spanishPositiveResponseFromChild: checkifEmpty(
          this.setData('messageResponsePositiveEs', ''),
        ),
        spanishNegativeResponseFromChild: checkifEmpty(
          this.setData('messageResponseNegativeEs', ''),
        ),
        englishPositiveResponseDataFromChild: this.setData(
          'messageResponsePositive',
          'setEnglishPositiveResponseData',
        ),
        englishNegativeResponseDataFromChild: this.setData(
          'messageResponseNegative',
          'setEnglishNegativeResponseData',
        ),
        spanishPositiveResponseDataFromChild: this.setData(
          'messageResponsePositiveEs',
          'setSpanishPositiveResponseData',
        ),
        spanishNegativeResponseDataFromChild: this.setData(
          'messageResponseNegativeEs',
          'setSpanishNegativeResponseData',
        ),
        validContactData: true,
        scheduleDataFromChild: this.latestDate(
          this.props.scheduleDataFromChild,
          FindTimezone(this.props.timezoneDataFromChild),
        ),
        ciData: this.setData('ciDataInput', 'setCIData'),
        listInput: this.setData('listDataInput', 'setListInputData'),
        listType: this.setData('listDataType', 'setListInputType'),
        headerTitle: setTitle(this.setData('ciDataInput', '')),
        timezoneDataFromChild: '',
      })
    }
  }

  latestDate(scheduleDataFromChild, timezone) {
    timezone = FindTimezone(timezone)
    var date = moment.tz(timezone)
    date.set({ second: 0 })
    var tempSchedule = moment.tz(scheduleDataFromChild, timezone)
    if (tempSchedule.isBefore(date)) {
      return date.toDate()
    }
    return scheduleDataFromChild
  }
  // function to set all of the properties for all the different methods they could be received
  setData(propName, setPropName, defaultValue = '') {
    let returnVar = defaultValue
    if (this.props[propName]) {
      if (setPropName !== '') {
        this.props[setPropName](this.props[propName])
      }
      returnVar = this.props[propName]
    } else if (this.props.location && this.props.location.state) {
      if (this.props.location.state[propName] !== undefined) {
        if (setPropName !== '') {
          this.props[setPropName](this.props.location.state[propName])
        }
        returnVar = this.props.location.state[propName]
      }
    }
    return returnVar
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const location = this.props.location || {}
    const nextLocation = nextProps.location || {}
    if (
      nextLocation.pathname &&
      location.pathname &&
      nextLocation.pathname !== location.pathname
    ) {
      this.setState({ ciData: nextProps.ciDataInput })
      this.setState({ listInput: nextProps.listDataInput })
      this.setState({ listType: nextProps.listDataType })
      this.setState({ headerTitle: setTitle(nextProps.ciDataInput) })
      this.setState({
        delayDataFromChild: setDelay(nextProps.ciDataInput),
      })
      this.setState({
        contactDataFromChild: initContactData(
          ('contactMethods', ''),
          nextProps.ciDataInput,
          '',
        ),
      })
      this.workerCallback({})
      this.handleReset()
    }
  }

  setActiveStep() {
    let activeStep = 0
    if (this.props.location && this.props.location.state) {
      if (this.props.location.state.startAtStep) {
        activeStep = this.props.location.state.startAtStep
      }
    }
    return activeStep
  }

  handleDateChange = (date) => {
    moment.tz.setDefault(this.state.timezoneDataFromChild)
    date = this.latestDate(date, this.state.timezoneDataFromChild)
    this.setState({ scheduleDataFromChild: date })
    this.props.setScheduleData(moment(date).format('MM/DD/YYYY HH:mm'))
  }

  selectionListCallback = (dataFromChild) => {
    this.setState({ selectionData: dataFromChild })
    this.props.setListSelectionData(dataFromChild)
  }
  // Modify the below to check if any restricted location(s) selected, populate boolean
  countryCodeCallback = (dataFromChild) => {
    Object.keys(dataFromChild)
    // Use for production when testing complete
    if (dataFromChild['CN'] === true) {
      // Use for testing only, switch back to CN when done testing
      // if (dataFromChild['IN'] === true) {
      this.setState({ countryLinkRestrictionFlagFromChild: true })
      this.props.setCountryLinkRestrictionFlag(true)
      this.notifyDataCallback(true)
    } else {
      this.setState({ countryLinkRestrictionFlagFromChild: false })
      this.props.setCountryLinkRestrictionFlag(false)
    }
  }
  workerCallback = (dataFromChild) => {
    this.setState({ listDataFromChild: dataFromChild })
    this.props.setListData(dataFromChild)
  }
  workerTotalCallback = (dataFromChild) => {
    this.setState({ listWorkerTotalFromChild: dataFromChild })
  }

  validProximityWorkerTypesCallback = (dataFromChild) => {
    this.setState({ validProximityWorkerTypes: dataFromChild })
  }

  componentDidUpdate(prevProps, prevState) {
    let shouldUpdate = false
    if (
      prevState.activeStep !== this.state.activeStep ||
      prevState.listDataFromChild !== this.state.listDataFromChild
    ) {
      this.setState({
        validData: isWorkerListPopulated(this.state.listDataFromChild),
      })
    }
    if (
      prevState.activeStep !== this.state.activeStep ||
      prevState.contactDataFromChild !== this.state.contactDataFromChild ||
      prevState.distanceFlagDataFromChild !==
        this.state.distanceFlagDataFromChild ||
      prevState.distanceDataFromChild !== this.state.distanceDataFromChild ||
      prevState.validProximityWorkerTypes !==
        this.state.validProximityWorkerTypes
    ) {
      shouldUpdate = true
      this.setState({
        validContactData: itemsValidation(
          this.state.contactDataFromChild,
          this.state.distanceFlagDataFromChild,
          this.state.distanceDataFromChild,
          this.state.validProximityWorkerTypes,
        ),
      })
    }
    if (
      prevState.activeStep !== this.state.activeStep ||
      prevState.contactDataFromChild !== this.state.contactDataFromChild ||
      prevState.titleFromChild !== this.state.titleFromChild ||
      prevState.phoneMessageFromChild !== this.state.phoneMessageFromChild ||
      prevState.smsMessageFromChild !== this.state.smsMessageFromChild ||
      prevState.emailMessageFromChild !== this.state.emailMessageFromChild ||
      prevState.notifyDataFromChild !== this.state.notifyDataFromChild ||
      prevState.languageDataFromChild !== this.state.languageDataFromChild ||
      prevState.englishPositiveResponseFromChild !==
        this.state.englishPositiveResponseFromChild ||
      prevState.englishNegativeResponseFromChild !==
        this.state.englishNegativeResponseFromChild ||
      prevState.spanishPositiveResponseFromChild !==
        this.state.spanishPositiveResponseFromChild ||
      prevState.spanishNegativeResponseFromChild !==
        this.state.spanishNegativeResponseFromChild ||
      prevState.smsMessageDataFromChild !==
        this.state.smsMessageDataFromChild ||
      prevState.englishPositiveResponseDataFromChild !==
        this.state.englishPositiveResponseDataFromChild ||
      prevState.englishNegativeResponseDataFromChild !==
        this.state.englishNegativeResponseDataFromChild ||
      prevState.spanishPositiveResponseDataFromChild !==
        this.state.spanishPositiveResponseDataFromChild ||
      prevState.spanishNegativeResponseDataFromChild !==
        this.state.spanishNegativeResponseDataFromChild
    ) {
      shouldUpdate = true
      this.setState({
        validMessage: isMessagePopulated(
          this.state.contactDataFromChild,
          this.state.titleFromChild,
          this.state.phoneMessageFromChild,
          this.state.smsMessageFromChild,
          this.state.emailMessageFromChild,
          this.state.notifyDataFromChild,
          this.state.languageDataFromChild,
          this.state.englishPositiveResponseFromChild,
          this.state.englishNegativeResponseFromChild,
          this.state.spanishPositiveResponseFromChild,
          this.state.spanishNegativeResponseFromChild,
          getTotalSMSCharacters(
            this.state.smsMessageDataFromChild,
            this.state.notifyDataFromChild,
            this.state.languageDataFromChild,
            this.state.englishPositiveResponseDataFromChild,
            this.state.englishNegativeResponseDataFromChild,
            this.state.spanishPositiveResponseDataFromChild,
            this.state.spanishNegativeResponseDataFromChild,
          ),
        ),
      })
    }
    return shouldUpdate
  }

  titleCallback = (dataFromChild) => {
    this.setState({ titleFromChild: dataFromChild })
  }
  phoneMessageCallback = (dataFromChild) => {
    this.setState({ phoneMessageFromChild: dataFromChild })
  }
  smsMessageCallback = (dataFromChild) => {
    this.setState({ smsMessageFromChild: dataFromChild })
  }
  emailMessageCallback = (dataFromChild) => {
    this.setState({ emailMessageFromChild: dataFromChild })
  }
  englishPositiveResponseCallback = (dataFromChild) => {
    this.setState({ englishPositiveResponseFromChild: dataFromChild })
  }
  englishNegativeResponseCallback = (dataFromChild) => {
    this.setState({ englishNegativeResponseFromChild: dataFromChild })
  }
  spanishPositiveResponseCallback = (dataFromChild) => {
    this.setState({ spanishPositiveResponseFromChild: dataFromChild })
  }
  spanishNegativeResponseCallback = (dataFromChild) => {
    this.setState({ spanishNegativeResponseFromChild: dataFromChild })
  }
  titleDataCallback = (dataFromChild) => {
    this.setState({ titleDataFromChild: dataFromChild })
    this.props.setTitleData(dataFromChild)
  }
  phoneMessageDataCallback = (dataFromChild) => {
    this.setState({ phoneMessageDataFromChild: dataFromChild })
    this.props.setPhoneMessageData(dataFromChild)
  }
  smsMessageDataCallback = (dataFromChild) => {
    this.setState({ smsMessageDataFromChild: dataFromChild })
    this.props.setSMSMessageData(dataFromChild)
  }
  emailMessageDataCallback = (dataFromChild) => {
    this.setState({ emailMessageDataFromChild: dataFromChild })
    this.props.setEmailMessageData(dataFromChild)
  }
  englishPositiveResponseDataCallback = (dataFromChild) => {
    this.setState({ englishPositiveResponseDataFromChild: dataFromChild })
    this.props.setEnglishPositiveResponseData(dataFromChild)
  }
  englishNegativeResponseDataCallback = (dataFromChild) => {
    this.setState({ englishNegativeResponseDataFromChild: dataFromChild })
    this.props.setEnglishNegativeResponseData(dataFromChild)
  }
  spanishPositiveResponseDataCallback = (dataFromChild) => {
    this.setState({ spanishPositiveResponseDataFromChild: dataFromChild })
    this.props.setSpanishPositiveResponseData(dataFromChild)
  }
  spanishNegativeResponseDataCallback = (dataFromChild) => {
    this.setState({ spanishNegativeResponseDataFromChild: dataFromChild })
    this.props.setSpanishNegativeResponseData(dataFromChild)
  }
  contactDataCallback = (dataFromChild) => {
    this.setState({ contactDataFromChild: dataFromChild })
    this.props.setContactData(dataFromChild)
  }
  delayDataCallback = (dataFromChild) => {
    this.setState({ delayDataFromChild: dataFromChild })
    this.props.setDelayData(dataFromChild)
  }
  notifyDataCallback = (dataFromChild) => {
    this.setState({ notifyDataFromChild: dataFromChild })
    this.props.setNotifyData(dataFromChild)
  }
  distanceFlagDataCallback = (dataFromChild) => {
    this.setState({ distanceFlagDataFromChild: dataFromChild })
    this.props.setDistanceFlagData(dataFromChild)
  }
  distanceDataCallback = (dataFromChild) => {
    this.setState({ distanceDataFromChild: dataFromChild })
    this.props.setDistanceData(dataFromChild)
  }
  workerTypesDataCallback = (dataFromChild) => {
    this.setState({ workerTypesDataFromChild: dataFromChild })
    this.props.setWorkerTypesData(dataFromChild)
  }
  contactDataCallbackValid = (dataFromChild) => {
    this.setState({ validContactData: dataFromChild })
  }
  languageDataCallback = (dataFromChild) => {
    this.setState({ languageDataFromChild: dataFromChild })
    this.props.setLanguageData(dataFromChild)
  }
  timezoneDataCallback = (dataFromChild) => {
    moment.tz.setDefault(dataFromChild)
    this.setState({ timezoneDataFromChild: dataFromChild })
    this.setState({
      scheduleDataFromChild: this.latestDate(
        this.state.scheduleDataFromChild,
        dataFromChild,
      ),
    })
  }

  getStepContent = (step) => {
    const { classes } = this.props
    let messagePhone = ''
    let messageSMS = ''
    let messageEmail = ''
    let languageResponse = ''
    let titleLanguage = ''
    let switchLanguage = ''
    let englishPositiveResponse = ''
    let englishNegativeResponse = ''
    let spanishPositiveResponse = ''
    let spanishNegativeResponse = ''
    let displayDistanceDropdown = ''
    let geolocation = ''
    let displayNotifyItem = ''
    let displayGeoLocTitle = ''
    let displayGeoLocItem = ''
    let smsCharacterCount = ''

    if (getContactMethods(this.state.contactDataFromChild, 'Phone')) {
      messagePhone = (
        <ListItem divider>
          <ListItemText
            primary="Phone Message Body"
            secondary={this.state.phoneMessageDataFromChild}
          />
        </ListItem>
      )
    }
    if (getContactMethods(this.state.contactDataFromChild, 'SMS')) {
      messageSMS = (
        <ListItem divider>
          <ListItemText
            primary="SMS Message Body"
            secondary={this.state.smsMessageDataFromChild}
          />
        </ListItem>
      )
      let totalSMSCharacters = getTotalSMSCharacters(
        this.state.smsMessageDataFromChild,
        this.state.notifyDataFromChild,
        this.state.languageDataFromChild,
        this.state.englishPositiveResponseDataFromChild,
        this.state.englishNegativeResponseDataFromChild,
        this.state.spanishPositiveResponseDataFromChild,
        this.state.spanishNegativeResponseDataFromChild,
      )
      let characterCountString =
        'Total characters used for SMS message: ' +
        String(totalSMSCharacters) +
        '/320'
      if (this.state.notifyDataFromChild === false) {
        characterCountString += ' (includes response URLs and text)'
      }
      smsCharacterCount = (
        <Box color="text.primary">
          <ListItem className={classes.centerListText}>
            <ListItemText primary={characterCountString} />
          </ListItem>
        </Box>
      )
      if (totalSMSCharacters > 160 && totalSMSCharacters <= 320) {
        smsCharacterCount = (
          <Box color="warning.main">
            <ListItem className={classes.centerListText}>
              <ListItemText primary={characterCountString} />
              <Tooltip title="Messages over 160 characters may be split into more than one SMS">
                <WarningIcon />
              </Tooltip>
            </ListItem>
          </Box>
        )
      } else if (totalSMSCharacters > 320) {
        smsCharacterCount = (
          <Box color="error.main">
            <ListItem className={classes.centerListText}>
              <ListItemText primary={characterCountString} />
              <Tooltip title="SMS messages must be less than 320 characters">
                <ErrorIcon />
              </Tooltip>
            </ListItem>
          </Box>
        )
      }
    }
    if (getContactMethods(this.state.contactDataFromChild, 'Email')) {
      messageEmail = (
        <ListItem divider>
          <ListItemText
            primary="Email Message Body"
            secondary={this.state.emailMessageDataFromChild}
          />
        </ListItem>
      )
    }
    if (this.state.notifyDataFromChild === false) {
      languageResponse = (
        <ListItem divider>
          <ListItemText
            primary="Languages for Responses"
            secondary={displayLanguage(this.state.languageDataFromChild)}
          />
        </ListItem>
      )
      titleLanguage = (
        <Typography component="span" variant="body2">
          Language to send on Responses
        </Typography>
      )
      switchLanguage = (
        <LanguageSwitch
          className={classes.centerListSmall}
          callbackFromParentLanguage={this.languageDataCallback}
          callbackFromParentEnglishPositiveResponse={
            this.englishPositiveResponseCallback
          }
          callbackFromParentEnglishPositiveResponseData={
            this.englishPositiveResponseDataCallback
          }
          callbackFromParentEnglishNegativeResponse={
            this.englishNegativeResponseCallback
          }
          callbackFromParentEnglishNegativeResponseData={
            this.englishNegativeResponseDataCallback
          }
          callbackFromParentSpanishPositiveResponse={
            this.spanishPositiveResponseCallback
          }
          callbackFromParentSpanishPositiveResponseData={
            this.spanishPositiveResponseDataCallback
          }
          callbackFromParentSpanishNegativeResponse={
            this.spanishNegativeResponseCallback
          }
          callbackFromParentSpanishNegativeResponseData={
            this.spanishNegativeResponseDataCallback
          }
          fromParentNotify={this.state.notifyDataFromChild}
          fromParentLanguageSelected={this.state.languageDataFromChild}
          fromParentEnglishPositiveResponseData={
            this.props.englishPositiveResponseDataFromChild
          }
          fromParentEnglishNegativeResponseData={
            this.props.englishNegativeResponseDataFromChild
          }
          fromParentSpanishPositiveResponseData={
            this.props.spanishPositiveResponseDataFromChild
          }
          fromParentSpanishNegativeResponseData={
            this.props.spanishNegativeResponseDataFromChild
          }
        />
      )
      englishPositiveResponse = (
        <ListItem divider>
          <ListItemText
            primary="English Positive Response Text"
            secondary={this.state.englishPositiveResponseDataFromChild}
          />
        </ListItem>
      )
      englishNegativeResponse = (
        <ListItem divider>
          <ListItemText
            primary="English Negative Response Text"
            secondary={this.state.englishNegativeResponseDataFromChild}
          />
        </ListItem>
      )
    }
    if (
      this.state.languageDataFromChild === false &&
      this.state.notifyDataFromChild === false
    ) {
      spanishPositiveResponse = (
        <ListItem divider>
          <ListItemText
            primary="Spanish Positive Response Text"
            secondary={this.state.spanishPositiveResponseDataFromChild}
          />
        </ListItem>
      )
      spanishNegativeResponse = (
        <ListItem divider>
          <ListItemText
            primary="Spanish Negative Response Text"
            secondary={this.state.spanishNegativeResponseDataFromChild}
          />
        </ListItem>
      )
    }
    if (this.props.countryLinkRestrictionFlagFromChild === false) {
      displayNotifyItem = (
        <NotifyItem
          className={classes.centerListSmall}
          callbackFromParentNotify={this.notifyDataCallback}
          notifyFromParent={this.state.notifyDataFromChild}
        />
      )
    }
    if (
      this.state.listInput !== true &&
      distroListOnlyValidation(this.state.listDataFromChild) === false
    ) {
      displayGeoLocTitle = (
        <Typography component="span" variant="body2">
          Choose to contact team members who live within set distance from
          selected locations
          <br />
          (in addition to team members who work at those locations)
          <br />
        </Typography>
      )
      displayGeoLocItem = (
        <DistanceItem
          className={classes.centerListSmall}
          callbackFromParentDistanceFlag={this.distanceFlagDataCallback}
          distanceFlagFromParent={this.state.distanceFlagDataFromChild}
        />
      )
    }

    if (this.state.distanceFlagDataFromChild) {
      displayDistanceDropdown = (
        <div>
          <Typography component="span" variant="body2">
            Optionally, you may also filter what type of team members to contact
            within selected distance.
          </Typography>
          <DistanceDropdownItem
            callbackFromParentDistance={this.distanceDataCallback}
            distanceFromParent={this.state.distanceDataFromChild}
            callbackFromParentWorkerTypes={this.workerTypesDataCallback}
            workerTypesFromParent={this.state.workerTypesDataFromChild}
            callbackFromParentIsValid={this.validProximityWorkerTypesCallback}
          />
        </div>
      )
    }
    if (this.state.distanceFlagDataFromChild) {
      geolocation = (
        <>
          <ListItem divider>
            <ListItemText
              primary="Contact nearby team members distance"
              secondary={this.state.distanceDataFromChild}
            />
          </ListItem>
          <ListItem divider>
            <ListItemText
              primary="Contact nearby team member types"
              secondary={displayProximityWorkerTypes(
                this.state.workerTypesDataFromChild,
              )}
            />
          </ListItem>
        </>
      )
    }

    switch (step) {
      case 0:
        if (this.setActiveStep() > 0) {
          return (
            <span>
              <Typography component="span" variant="body2">
                Option not available when using a follow-up campaign
              </Typography>
              <br />
            </span>
          )
        } else {
          return (
            <span>
              {this.state.listInput === true && (
                <WorkerTextBox
                  callbackFromParent={this.workerCallback}
                  callbackFromParentTotals={this.workerTotalCallback}
                  workerListFromParent={this.state.listDataFromChild}
                  blossomIDFromParent={this.state.ciData}
                  listDataTypeFromParent={this.state.listType}
                />
              )}
              {this.state.listInput !== true && (
                <WorkerLookupTable
                  callbackFromParent={this.workerCallback}
                  callbackFromParentTotals={this.workerTotalCallback}
                  blossomIDFromParent={this.state.ciData}
                  callbackFromParentSelections={this.selectionListCallback}
                  callbackFromParentCountryCode={this.countryCodeCallback}
                />
              )}
            </span>
          )
        }
      case 1:
        return (
          <div>
            <Typography component="span" variant="body2">
              Select how you want the message sent.
            </Typography>
            <ReorderList
              className={classes.centerListSmall}
              callbackFromParentContactMethodList={this.contactDataCallback}
              itemsFromParent={this.state.contactDataFromChild}
              callbackFromParentContactMethodValid={
                this.contactDataCallbackValid
              }
              hidePhoneFromParent={setHidePhoneFlag(this.state.ciData)}
            />
            <br />
            <Typography component="span" variant="body2">
              Select Delay Between Contact Methods.
              <br />
              NOTE: The 2 minute delay option (with No Response Links) will send
              notifications to all Contact Methods at once.
              <br />
            </Typography>
            <DelayItem
              className={classes.centerListSmall}
              callbackFromParentDelay={this.delayDataCallback}
              delayFromParent={this.state.delayDataFromChild}
            />
            {displayNotifyItem}
            {displayGeoLocTitle}
            {displayGeoLocItem}
            {displayDistanceDropdown}
            <br />
            <br />
          </div>
        )
      case 2:
        return (
          <div>
            <Typography component="span" variant="body2">
              Select a Message Template or Click Next to Continue
            </Typography>
            <MessageTemplateSelectPage
              callbackFromParentTitle={this.titleCallback}
              callbackFromParentTitleData={this.titleDataCallback}
              callbackFromParentPhoneMessage={this.phoneMessageCallback}
              callbackFromParentPhoneMessageData={this.phoneMessageDataCallback}
              callbackFromParentSMSMessage={this.smsMessageCallback}
              callbackFromParentSMSMessageData={this.smsMessageDataCallback}
              callbackFromParentEmailMessage={this.emailMessageCallback}
              callbackFromParentEmailMessageData={this.emailMessageDataCallback}
              callbackFromParentEnglishPositiveResponse={
                this.englishPositiveResponseCallback
              }
              callbackFromParentEnglishPositiveResponseData={
                this.englishPositiveResponseDataCallback
              }
              callbackFromParentEnglishNegativeResponse={
                this.englishNegativeResponseCallback
              }
              callbackFromParentEnglishNegativeResponseData={
                this.englishNegativeResponseDataCallback
              }
              callbackFromParentSpanishPositiveResponse={
                this.spanishPositiveResponseCallback
              }
              callbackFromParentSpanishPositiveResponseData={
                this.spanishPositiveResponseDataCallback
              }
              callbackFromParentSpanishNegativeResponse={
                this.spanishNegativeResponseCallback
              }
              callbackFromParentSpanishNegativeResponseData={
                this.spanishNegativeResponseDataCallback
              }
              fromParentblossomID={this.state.ciData}
            />
          </div>
        )
      case 3:
        return (
          <div>
            <MessageCreateForm
              callbackFromParentTitle={this.titleCallback}
              callbackFromParentTitleData={this.titleDataCallback}
              callbackFromParentPhoneMessage={this.phoneMessageCallback}
              callbackFromParentPhoneMessageData={this.phoneMessageDataCallback}
              callbackFromParentSMSMessage={this.smsMessageCallback}
              callbackFromParentSMSMessageData={this.smsMessageDataCallback}
              callbackFromParentEmailMessage={this.emailMessageCallback}
              callbackFromParentEmailMessageData={this.emailMessageDataCallback}
              fromParentTitleData={this.props.titleDataFromChild}
              fromParentContactMethods={this.state.contactDataFromChild}
              fromParentPhoneMessageData={this.props.phoneMessageDataFromChild}
              fromParentSMSMessageData={this.props.smsMessageDataFromChild}
              fromParentEmailMessageData={this.props.emailMessageDataFromChild}
              fromParentCountryLinkRestrictionFlag={
                this.state.countryLinkRestrictionFlagFromChild
              }
              // fromParentblossomID={this.state.ciData}
              fromParentIsTemplate={false}
            />
            <br />
            {titleLanguage}
            {switchLanguage}
            {smsCharacterCount}
          </div>
        )
      case 4:
        return (
          <div>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              {/* <MuiPickersUtilsProvider utils={DateFnsUtils}> */}

              <DateTimePicker
                label="Send Message At"
                style={{ width: 200 }}
                value={this.latestDate(
                  this.state.scheduleDataFromChild,
                  this.state.timezoneDataFromChild,
                )}
                onChange={this.handleDateChange}
                disablePast
                showTodayButton
                dateRangeIcon={<DateRange />}
                timeIcon={<AccessTime />}
                leftArrowIcon={<ArrowBack />}
                rightArrowIcon={<ArrowForward />}
              />
            </MuiPickersUtilsProvider>
            <SelectTimezoneItem
              callbackFromParentTimezone={this.timezoneDataCallback}
              timezoneFromParent={this.state.timezoneDataFromChild}
            />
            <br />
            <br />
            <Typography component="span">
              If the Time or Date is in the past, it will be sent immediately.
            </Typography>
            <br />
            <br />
          </div>
        )
      case 5:
        return (
          <div>
            <Typography component="span" variant="h6">
              Final notification details
            </Typography>
            <List className={classes.centerList}>
              <ListItem divider>
                <ListItemText
                  primary="Message Title"
                  secondary={this.state.titleDataFromChild}
                />
              </ListItem>
              {messagePhone}
              {messageSMS}
              {messageEmail}
              {languageResponse}
              {englishPositiveResponse}
              {englishNegativeResponse}
              {spanishPositiveResponse}
              {spanishNegativeResponse}
              <ListItem divider>
                <ListItemText
                  primary="Contact Method"
                  secondary={displayContactMethod(
                    this.state.contactDataFromChild,
                  )}
                />
              </ListItem>
              <ListItem divider>
                <ListItemText
                  primary="Delay After SMS and Email"
                  secondary={displayDelay(this.state.delayDataFromChild)}
                />
              </ListItem>
              <ListItem divider>
                <ListItemText
                  primary="Notify Only"
                  secondary={displayNotify(this.state.notifyDataFromChild)}
                />
              </ListItem>
              {geolocation}
              <ListItem divider>
                <ListItemText
                  primary="Message Schedule"
                  secondary={finaltime(
                    this.latestDate(this.state.scheduleDataFromChild),
                    this.state.timezoneDataFromChild,
                  )}
                />
              </ListItem>
              {!this.setActiveStep() && (
                <ListItem divider>
                  <ListItemText
                    primary="Contacts"
                    secondary={displayContacts(this.state.listDataFromChild)}
                  />
                </ListItem>
              )}
              <ListItem divider={false}>
                <ListItemText
                  primary="Number of Team Members Selected"
                  secondary={this.state.listWorkerTotalFromChild}
                />
              </ListItem>
            </List>
            <br />
            <br />
          </div>
        )
      default:
        return 'Houston we have a problem!  Unknown Step.'
    }
  }

  // STEPPER INIT START ---------------------------
  isStepSkipped(step) {
    return this.state.skipped.has(step)
  }

  handleNext = () => {
    const { activeStep } = this.state
    const steps = getSteps()
    let { skipped } = this.state
    if (this.isStepSkipped(activeStep)) {
      skipped = new Set(skipped.values())
      skipped.delete(activeStep)
    }
    this.setState({
      activeStep: activeStep + 1,
      skipped,
    })
    if (activeStep === steps.length - 1) {
      this.handleClickOpen()
    }
  }

  handleBack = () => {
    const { activeStep } = this.state
    this.setState({
      activeStep: activeStep - 1,
    })
  }

  handleSkip = () => {
    const { activeStep } = this.state
    const skipped = new Set(this.state.skipped.values())
    skipped.add(activeStep)
    this.setState({
      activeStep: this.state.activeStep + 1,
      skipped,
    })
  }

  handleReset(buttonPushed = false) {
    if (buttonPushed) {
      this.setState({
        contactDataFromChild: initContactData(
          ('contactMethods', ''),
          this.state.ciData,
          '',
        ),
      })
    }
    this.setState({
      countryLinkRestrictionFlagFromChild: false,
      listDataFromChild: {},
      listWorkerTotalFromChild: 0,
      activeStep: 0,
      skipped: new Set(),
      validData: false,
      titleFromChild: true,
      phoneMessageFromChild: true,
      smsMessageFromChild: true,
      emailMessageFromChild: true,
      validMessage: false,
      titleDataFromChild: '',
      phoneMessageDataFromChild: null,
      smsMessageDataFromChild: null,
      emailMessageDataFromChild: null,
      dialogOpen: false,
      submitResponse: '',
      // delayDataFromChild: true,
      notifyDataFromChild: true,
      distanceFlagDataFromChild: false,
      distanceDataFromChild: 0,
      workerTypesDataFromChild: {
        str: true,
        office: true,
        rgd: true,
        dc: true,
        test: true,
        shipt: true,
      },
      languageDataFromChild: true,
      englishPositiveResponseFromChild: true,
      englishNegativeResponseFromChild: true,
      spanishPositiveResponseFromChild: true,
      spanishNegativeResponseFromChild: true,
      englishPositiveResponseDataFromChild: null,
      englishNegativeResponseDataFromChild: null,
      spanishPositiveResponseDataFromChild: null,
      spanishNegativeResponseDataFromChild: null,
      validContactData: true,
      scheduleDataFromChild: new Date(),
    })
  }

  updateResponseMessage(notifyFlag, languageFlag) {
    if (notifyFlag) {
      this.setState(
        {
          englishPositiveResponseDataFromChild: null,
          englishNegativeResponseDataFromChild: null,
          spanishPositiveResponseDataFromChild: null,
          spanishNegativeResponseDataFromChild: null,
        },
        this.submitUI,
      )
    } else if (languageFlag === true) {
      this.setState(
        {
          spanishPositiveResponseDataFromChild: null,
          spanishNegativeResponseDataFromChild: null,
        },
        this.submitUI,
      )
    } else {
      this.submitUI()
    }
  }

  submitUI() {
    this.props.homepageCreate(
      this.state.ciData,
      this.state.listDataFromChild,
      this.state.contactDataFromChild,
      setPrimaryJobCodes(this.state.ciData),
      setFailoverJobCodes(this.state.ciData),
      setNotifySupervisorJobCodesList(this.state.ciData),
      this.state.delayDataFromChild,
      setDistance(this.state.distanceFlagDataFromChild),
      setWorkerType(
        displayProximityWorkerTypes(this.state.workerTypesDataFromChild),
      ),
      moment
        .tz(
          moment(this.state.scheduleDataFromChild).format(
            'YYYY-MM-DD HH:mm:ss',
          ),
          this.state.timezoneDataFromChild,
        )
        .toISOString(),
      this.state.titleDataFromChild,
      this.state.phoneMessageDataFromChild,
      this.state.smsMessageDataFromChild,
      this.state.emailMessageDataFromChild,
      this.state.englishPositiveResponseDataFromChild,
      this.state.englishNegativeResponseDataFromChild,
      this.state.spanishPositiveResponseDataFromChild,
      this.state.spanishNegativeResponseDataFromChild,
    )
  }

  // STEPPER INIT END ---------------------------

  // HANDLE DIALOG --------------------
  handleClickOpen = () => {
    this.setState({ dialogOpen: true })
    // added check to reset response message values to null if will not be used
    this.updateResponseMessage(
      this.state.notifyDataFromChild,
      this.state.languageDataFromChild,
    )
  }

  handleClose = () => {
    this.setState({ dialogOpen: false })
  }

  // HANDLE DIALOG END ----------------
  render() {
    const { classes } = this.props
    const { headerTitle } = this.state

    const steps = getSteps()
    const { activeStep, validData, validMessage, validContactData } = this.state
    let myTitle = 'T.O.M. - Target Outreach Manager - ' + headerTitle

    return (
      <div className={classes.homePage}>
        <HeaderTitle title={myTitle} />
        <Helmet>
          <title>{headerTitle}</title>
        </Helmet>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <div className={classes.homePage}>
            <Stepper activeStep={activeStep}>
              {steps.map((label, index) => {
                const props = {}
                const labelProps = {}
                if (this.isStepSkipped(index)) {
                  props.completed = false
                }
                return (
                  <Step key={label} {...props}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                )
              })}
            </Stepper>
            <div>
              {activeStep === steps.length ? (
                <div>
                  <HomepageResponse />
                  <br />
                  <br />
                  <Button
                    onClick={() => this.handleReset(true)}
                    className={classes.button}
                  >
                    Reset
                  </Button>
                </div>
              ) : (
                <div>
                  <Typography component="span" className={classes.instructions}>
                    {this.getStepContent(activeStep)}
                  </Typography>
                  <div>
                    <Button
                      disabled={activeStep === 0}
                      onClick={this.handleBack}
                      className={classes.button}
                    >
                      Back
                    </Button>
                    <Button
                      disabled={
                        (activeStep === 0 && !validData) ||
                        (activeStep === 1 && !validContactData) ||
                        (activeStep === 3 && !validMessage)
                      }
                      variant="contained"
                      color="primary"
                      onClick={this.handleNext}
                      className={classes.button}
                    >
                      {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </MuiPickersUtilsProvider>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setListSelectionData,
      setCountryLinkRestrictionFlag,
      setListData,
      setTitleData,
      setPhoneMessageData,
      setSMSMessageData,
      setEmailMessageData,
      setContactData,
      setDelayData,
      setNotifyData,
      setDistanceFlagData,
      setDistanceData,
      setWorkerTypesData,
      setLanguageData,
      setEnglishPositiveResponseData,
      setEnglishNegativeResponseData,
      setSpanishPositiveResponseData,
      setSpanishNegativeResponseData,
      setScheduleData,
      setCIData,
      setListInputData,
      setListInputType,
      homepageCreate,
    },
    dispatch,
  )

const mapStateToProps = (state) => ({
  selectionData: state.homepageCreate.selections,
  countryLinkRestrictionFlagFromChild:
    state.homepageCreate.inputCountryLinkRestrictionFlag,
  listDataFromChild: state.homepageCreate.inputListData,
  titleDataFromChild: state.homepageCreate.inputTitleData,
  phoneMessageDataFromChild: state.homepageCreate.inputPhoneMessageData,
  smsMessageDataFromChild: state.homepageCreate.inputSMSMessageData,
  emailMessageDataFromChild: state.homepageCreate.inputEmailMessageData,
  contactDataFromChild: state.homepageCreate.inputContactData,
  delayDataFromChild: state.homepageCreate.inputDelayData,
  notifyDataFromChild: state.homepageCreate.inputNotifyData,
  distanceFlagDataFromChild: state.homepageCreate.inputDistanceFlagData,
  distanceDataFromChild: state.homepageCreate.inputDistanceData,
  workerTypesDataFromChild: state.homepageCreate.inputWorkerTypesData,
  languageDataFromChild: state.homepageCreate.inputLanguageData,
  englishPositiveResponseDataFromChild:
    state.homepageCreate.inputEnglishPositiveResponseData,
  englishNegativeResponseDataFromChild:
    state.homepageCreate.inputEnglishNegativeResponseData,
  spanishPositiveResponseDataFromChild:
    state.homepageCreate.inputSpanishPositiveResponseData,
  spanishNegativeResponseDataFromChild:
    state.homepageCreate.inputSpanishNegativeResponseData,
  scheduleDataFromChild: state.homepageCreate.inputScheduleData,
  ciData: state.homepageCreate.inputCIData,
  listInput: state.homepageCreate.inputListInputData,
  listType: state.homepageCreate.inputListInputType,
  // headerTitle: state.headerTitle,
})

const HomePageWithContext = withOutletContext(HomePage)
const StyledConnectedHomePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(HomePageWithContext))

export default StyledConnectedHomePage
